import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { formatIstDateKey, isIstToday, useIstClock } from './ist-datetime';
import './GlobalSoldTodayBar.css';

function fmtRs(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '₹0';
  return `₹${v.toFixed(v % 1 === 0 ? 0 : 2)}`;
}

/**
 * Permanent sold-today strip — visible on every trading screen (Options, V1, Degen, CNC, Report, etc.)
 */
export default function GlobalSoldTodayBar() {
  const { pathname } = useLocation();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await axios.get('/api/normal-v1/sold-history', { timeout: 12000 });
      setData(res.data);
      setError(false);
    } catch {
      setError(true);
    }
  }, []);

  useEffect(() => {
    load();
    const timer = setInterval(load, 20000);
    return () => clearInterval(timer);
  }, [load, pathname]);

  const today = data?.todayDate || '';
  const liveNow = useIstClock();
  const todayLabel = today ? (isIstToday(today) ? liveNow : formatIstDateKey(today)) : '';
  const todayCount = data?.counts?.today ?? 0;
  const totalCount = data?.counts?.total ?? 0;
  const todayPnl = (data?.dailyTotals || []).find((d) => d.date === today)?.totalPnl
    ?? (data?.soldToday || []).reduce((s, r) => s + (Number(r.pnl) || 0), 0);

  return (
    <div className="global-sold-today-bar" role="region" aria-label="Sold today permanent history">
      <Link to="/NormalTrading/Sold" className="global-sold-today-link">
        <span className="global-sold-today-icon" aria-hidden>✅</span>
        <strong>Sold Today</strong>
        <em className="global-sold-today-count">{todayCount}</em>
      </Link>
      <span className="global-sold-today-meta">
        {error ? (
          'History server offline — refresh when backend is back'
        ) : (
          <>
            Today ({todayLabel || '—'}) profit <strong>{fmtRs(todayPnl)}</strong>
            <span className="global-sold-today-sep">·</span>
            All-time <strong>{totalCount}</strong> sells (never deleted)
          </>
        )}
      </span>
      <Link to="/NormalTrading/Sold" className="global-sold-today-view">
        View full history →
      </Link>
    </div>
  );
}
